var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcAppointment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M76 34.047v34.486A7.477 7.477 0 0 1 68.533 76H25.6a7.373 7.373 0 0 1-4.256-1.344A7.4 7.4 0 0 1 20 70.4V35.913a7.477 7.477 0 0 1 7.467-7.466H68.47c1.293-.001 7.47 5.46 7.467 6.984L76 34.047Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M76 35.913v3.743a.933.933 0 0 1-.933.933H20.933a.933.933 0 0 1-.933-.933v-3.743a7.477 7.477 0 0 1 7.467-7.466h41.066A7.477 7.477 0 0 1 76 35.913Z",
  fill: "#F4CC54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.143 23.192v9.483a3.188 3.188 0 0 1-3.183 3.192h-2.053a3.146 3.146 0 0 1-2.651-1.438 2.723 2.723 0 0 1-.327-.634 3.181 3.181 0 0 1-.205-1.12v-9.483A3.188 3.188 0 0 1 33.907 20h2.053c.38 0 .756.07 1.11.205.226.08.439.19.635.327a3.15 3.15 0 0 1 1.438 2.66ZM67.142 23.192v9.483a3.188 3.188 0 0 1-3.182 3.192h-2.053a3.146 3.146 0 0 1-2.651-1.438 2.723 2.723 0 0 1-.327-.634 3.181 3.181 0 0 1-.205-1.12v-9.483A3.188 3.188 0 0 1 61.907 20h2.053c.38 0 .756.07 1.11.205.226.08.439.19.635.327a3.15 3.15 0 0 1 1.438 2.66Z",
  fill: "#405B73"
})));
export default SvgIcAppointment;